import { render, staticRenderFns } from "./ContractStat.vue?vue&type=template&id=4b2b49d7&scoped=true&"
import script from "./ContractStat.vue?vue&type=script&lang=js&"
export * from "./ContractStat.vue?vue&type=script&lang=js&"
import style0 from "./ContractStat.vue?vue&type=style&index=0&id=4b2b49d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b49d7",
  null
  
)

export default component.exports